import Startup from '@/views/startups/Startup'
import Startups from "@/views/startups/Search";

export default [
    {
        path: '/startups',
        component: Startups,
        meta: {
            access: ['enterprise','ecosystem'],
            title: 'Startups',
            accountAccess: ['premium'],
        }
    },
    {
        path: '/startups/:id',
        component: Startup,
        meta: {
            access: ['enterprise','ecosystem']
        }
    },

    {
        path: '/public-startup/:domain',
        component: Startup,
        meta: {
            guest: true,
            onlyGuest: true,
        }
    },
]
